import { Component, OnInit } from '@angular/core';
import {NgbModal, ModalDismissReasons,NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-attperiod',
  templateUrl: './attperiod.component.html',
  styleUrls: ['./attperiod.component.scss']
})
export class AttperiodComponent implements OnInit {

  
    closeResult: string;
    modalOptions:NgbModalOptions;
    private modalRef: NgbModalRef;
    
     data = [
       {
         id: 1,
         name: 'Usa'
       },
       {
         id: 2,
         name: 'England'
       }
    ];

    sections:any=[];
    classes:any=[];
    arrstudent:any=[];
    fmodel:any={clid:'0',secid:'0',subid:'0',prid:'0'};
    arrrepdata:any=[];
    arrper:any=[];
    arrashead:any=[];
    arrastype:any=[];
    oprtype:any='';
    tabledata: any = {};
  
    constructor(private modalService: NgbModal) { }
    
    open(content) {
      this.modalOptions = {
       
        size:'md'
       
      }
      this.modalService.open(content, this.modalOptions ).result.then((result) => {
        this.closeResult = `Closed with: ${result}`;
      }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });
    }
   
    private getDismissReason(reason: any): string {
      if (reason === ModalDismissReasons.ESC) {
        return 'by pressing ESC';
      } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
        return 'by clicking on a backdrop';
      } else {
        return `with: ${reason}`;
      }
    }
  
    ngOnInit(): void {
    }


    
  
  }
